import { fabric } from "fabric";
import { IObjectOptions } from "fabric/fabric-impl";
import { AnnotationObjectDefaultProperties, ShapeGetData, ShapeOptions } from "./annotation-type";

export class Star extends fabric.Polygon implements ShapeGetData {
	private originalWidth!: number;
	private originalHeight!: number;
	constructor(private options: ShapeOptions, objectOptions?: IObjectOptions) {
		super(Star.starPolygonPoints(options.width, options.height), {
			...objectOptions,
			...AnnotationObjectDefaultProperties,
			left: options.x,
			top: options.y,
			stroke: options.color,
			width: options.width,
			height: options.height,
			scaleX: Star.getScaleX(options.width, options.height),
			scaleY: Star.getScaleY(options.width, options.height),
			angle: options.rotate,
			fill: options.fill,
			opacity: options.opacity
		});
		this.originalWidth = options.width;
		this.originalHeight = options.height;
		this.setControlsVisibility({
			mt: false, // middle top
			mb: false, // midle bottom
			ml: false, // middle left
			mr: false // middle right
		});
	}

	private static getScaleX(width: number, height: number): number {
		const scaleX = Math.abs(width - height) / height + 1;
		const isScaleApplied = width > height;
		const defaultScaleX = 1;
		return isScaleApplied ? scaleX : defaultScaleX;
	}
	private static getScaleY(width: number, height: number): number {
		const scaleY = Math.abs(width - height) / width + 1;
		const isScaleYApplied = height > width;
		const defaultScaleY = 1;
		return isScaleYApplied ? scaleY : defaultScaleY;
	}
	private static getOuterRadius(width: number, height: number): number {
		return Math.min(width, height) / 2;
	}
	private static starPolygonPoints(width: number, height: number) {
		const spikeCount = 5;
		const outerRadius = Math.min(width, height) / 2;
		const innerRadius = outerRadius / 2;
		let rot = (Math.PI / 2) * 3;
		const cx = outerRadius;
		const cy = outerRadius;
		const sweep = Math.PI / spikeCount;
		const points: { x: number; y: number }[] = [];

		for (let i = 0; i < spikeCount; i++) {
			let x = cx + Math.cos(rot) * outerRadius;
			let y = cy + Math.sin(rot) * outerRadius;
			points.push({ x: x, y: y });
			rot += sweep;

			x = cx + Math.cos(rot) * innerRadius;
			y = cy + Math.sin(rot) * innerRadius;
			points.push({ x: x, y: y });
			rot += sweep;
		}
		return points;
	}

	public setData(update: Partial<ShapeOptions>): void {
		Object.assign(this.options, update);

		this.setOptions({
			left: this.options.x,
			top: this.options.y,
			stroke: this.options.color,
			width: this.options.width,
			height: this.options.height,
			scaleX: Star.getScaleX(this.options.width, this.options.height),
			scaleY: Star.getScaleY(this.options.width, this.options.height),
			angle: this.options.rotate
		});
	}
	public getData(): ShapeOptions {
		const w = this.originalWidth;
		const h = this.originalHeight;
		const scaleX = this.scaleX!;
		const scaleY = this.scaleY!;
		return {
			type: this.options.type,
			width: w * scaleX,
			height: h * scaleY,
			x: this.left!,
			y: this.top!,
			color: this.stroke!,
			rotate: this.angle || 0,
			fill: this.fill,
			opacity: this.opacity!
		};
	}
}
